/*
 *   File : phone-number-change-status.js
 *   Author : https://evoqins.com
 *   Description : phone number change status modal
 *   Integrations : NA
 *   Version : 1.0.0
 *   Date : 25-05-2024
*/

import { memo } from "react";

// Assest 
import PhoneNumberChangeSuccess from "../../Assets/Images/success.webp";
import CloseBtn from "../../Assets/Images/close-btn-white.svg";

function PhoneNumberChangeStatusModal(props) {

    return (
        <div className="modal fade p-0 m-0"
            id="phone-number-change-status-modal"
            tabIndex="-1"
            aria-labelledby="PhoneNumberChangeStatusModal"
            data-bs-backdrop="static"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered min-h90vh">
                <div className=" modal-content e-bg-lotion e-border-radius-24 e-modal-box-shadow ">
                    <div className="modal-gradient-bg d-flex flex-column align-items-center modal-body p-4 e-border-radius-24">
                        <img src={CloseBtn}
                            draggable={false}
                            className='cursor-pointer float-end align-self-end'
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            alt='close'
                            onClick={props.onClose} />
                        <img className="img-fluid col-5 mt-4 pt-3"
                            draggable={false}
                            src={PhoneNumberChangeSuccess}
                            alt="payment status image" />
                        <p className="e-font-14-res text-center e-text-ufo-green e-alt-font-poppins e-font-18 e-font-weight-600 mt-4 mb-2">
                            Phone number changed successfully
                        </p>
                        <p className="e-font-12-res line-height-20px-res col-sm-10 mx-auto text-center e-text-dark-liver e-alt-font-poppins e-font-14 e-font-weight-400 line-height-26px text-center mx-auto mb-0 mb-5 ">
                            Phone number updated successfully, you will get all notification and important announcement to your updated new phone number.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(PhoneNumberChangeStatusModal);